export default {"src":"/_next/static/media/stripe-teal.a6653cb6.svg","height":24,"width":110};